import { Card, Group, Skeleton, Stack } from '@mantine/core';
import { memo } from 'react';

export const MetricsOverviewTabSkeleton = memo(
	({ cards = 4 }: { cards?: number }) => (
		<Stack spacing="lg">
			<Group position="apart">
				<Skeleton height={36} width={200} />
				<Skeleton height={36} width={150} />
			</Group>

			<Group grow>
				{Array.from({ length: cards }).map((_, index) => (
					<Card p={0} key={index}>
						<Skeleton height={100} width="100%" />
					</Card>
				))}
			</Group>
			<Card p={0}>
				<Skeleton height={400} width="100%" />
			</Card>
		</Stack>
	)
);
